import { render, staticRenderFns } from "./afterSaleService.vue?vue&type=template&id=7af4b96d&scoped=true"
import script from "./afterSaleService.vue?vue&type=script&lang=js"
export * from "./afterSaleService.vue?vue&type=script&lang=js"
import style0 from "./afterSaleService.vue?vue&type=style&index=0&id=7af4b96d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af4b96d",
  null
  
)

export default component.exports